import Component from '@glimmer/component';
import { t } from 'ember-intl';
import {
  HdsPageHeader,
  HdsApplicationState,
} from '@hashicorp/design-system-components/components';
import { CoreLayoutMain, BreadcrumbsContainer } from 'core/components';
import { boxPadding } from 'core/modifiers';
import UpdateListTable from 'hcp/components/iam/groups/members/update-list-table';

/**
 *
 * `PageGroupsOrganizationDetailAddMembersComponent` shows a list of organization principals that can be added to a group.
 *
 *
 * ```
 * <Page::Groups::Organization::Detail::Members::Add
 *   @group={{@model.group}}
 *   @eligibleMembers={{@model.eligibleMembers}}
 * />
 * ```
 *
 * @class PageGroupsOrganizationDetailAddMembersComponent
 *
 */
export default class PageGroupsOrganizationDetailAddMembers extends Component {
  <template>
    <CoreLayoutMain data-test-groups-organization-detail-members-add>
      <:header>
        <HdsPageHeader as |P|>
          <P.Title>{{t
              "components.page.access-control.groups.detail.members.add-members.title"
            }}</P.Title>
          <P.Breadcrumb>
            <BreadcrumbsContainer />
          </P.Breadcrumb>
          <P.IconTile @icon="users" @iconSecondary="plus" />
          <P.Subtitle>
            {{@group.displayName}}
          </P.Subtitle>
          <P.Description>
            {{t
              "components.page.access-control.groups.detail.members.add-members.description"
            }}
          </P.Description>
        </HdsPageHeader>
      </:header>
      {{! TODO: https://hashicorp.atlassian.net/browse/HCPIE-492 }}
      {{! <:alert>
    <Hds::Alert @type='inline' as |A|>
      <A.Title>
        Title here
      </A.Title>
      <A.Description>
        Description here
      </A.Description>
    </Hds::Alert>
  </:alert> }}
      <:body>
        {{#if @eligibleMembers}}
          <UpdateListTable
            @submitBtnText={{t
              "components.iam.groups.form.add-group-members.cta"
            }}
            @group={{@group}}
            @eligibleMembers={{@eligibleMembers}}
            @mode="add"
          />
        {{else}}
          <div
            {{boxPadding "xl 0"}}
            data-test-groups-organization-detail-members-add-application-state
          >
            <HdsApplicationState as |A|>
              <A.Header
                @title={{t
                  "components.page.groups.organization.detail.members.add.no-eligible-members"
                }}
              />
              <A.Body
                @text={{t
                  "components.page.groups.organization.detail.members.add.there-are-no-more-eligible-members-to-add-to-this-group"
                }}
              />
            </HdsApplicationState>
          </div>
        {{/if}}
      </:body>
    </CoreLayoutMain>
  </template>
}
